import React from 'react';
import PropTypes from 'prop-types';

import { useApplicationState, useLabel } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

import { useQuickDepositPostHog } from 'hooks/usePostHog';
import { QUICK_DEPOSIT_POPUP_TITLE_TYPE } from 'src/common/constants';
import {
  QuickDepositBonusProvider,
  useQuickDepositBonusContext,
} from 'src/components/QuickDepositPopup/QuickDepositBonusContext';
import QuickDepositForm from 'src/components/QuickDepositPopup/QuickDepositForm';

const fallbackMinBonusAmount = 3000;

const QuickDepositPopupContent = ({ afterDelay, onClose, onCloseClick }) => {
  const { wallet } = useApplicationState();
  const { currency } = wallet;
  const bonusContextValue = useQuickDepositBonusContext();
  const bonus =
    bonusContextValue?.activatedBonus ||
    bonusContextValue?.selectedBonus ||
    bonusContextValue?.bonusesList?.[0] ||
    bonusContextValue?.availableBonuses?.[0] ||
    null;
  const minBonusAmount =
    bonus?.financeData?.minDeposit ??
    bonus?.financeDataList?.find(item => item.currency === currency)?.minDeposit ??
    fallbackMinBonusAmount;
  const subtitle = useLabel('quick_deposit_to_activate', {
    currency,
    minBonusAmount,
  });

  const { handleCloseClick, handleDepositStart, handleDepositSuccess } = useQuickDepositPostHog({
    afterDelay,
    onCloseClick,
  });

  return (
    <DefaultPopup
      className="quick-deposit"
      headerTitle="quick_deposit_header"
      headerTitleClass="quick-deposit-header"
      headerTitlePosition="left"
      onClose={handleCloseClick}
      postHeaderTitle={subtitle}
    >
      <QuickDepositForm
        closeQRCodeOnSuccess
        onClose={onClose}
        onDepositStart={handleDepositStart}
        onDepositSuccess={handleDepositSuccess}
        titleType={QUICK_DEPOSIT_POPUP_TITLE_TYPE.QUICK_DEPOSIT}
      />
    </DefaultPopup>
  );
};

QuickDepositPopupContent.propTypes = {
  afterDelay: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};
const QuickDepositPopup = props => {
  const bonusContextValue = useQuickDepositBonusContext();

  if (!bonusContextValue) {
    return (
      <QuickDepositBonusProvider>
        <QuickDepositPopupContent {...props} />
      </QuickDepositBonusProvider>
    );
  }

  return <QuickDepositPopupContent {...props} />;
};

QuickDepositPopup.propTypes = QuickDepositPopupContent.propTypes;

export default QuickDepositPopup;
